import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { MaterialsSection } from './components/MaterialsSection';
import { ScreenTime } from './components/ScreenTime';
import { ForYourChild } from './components/ForYourChild';
import { HowItWorks } from './components/HowItWorks';
import { WhyItWorks } from './components/WhyItWorks';
import { VideoPreview } from './components/VideoPreview';
import { ProjectsGallery } from './components/ProjectsGallery';
import { WhatsIncluded } from './components/WhatsIncluded';
import { Offer } from './components/Offer';
import { BonosCarousel } from './components/BonosCarousel';
import { Testimonials } from './components/Testimonials';
import { FinalOffer } from './components/FinalOffer';
import { Faq } from './components/Faq';
import { StickyCta } from './components/StickyCta';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-full bg-white" data-id="element-0" data-mp="23ujha3i1d6za">
      <Navbar data-id="element-1" data-mp="3ik7gwiph6frp" />
      <main data-id="element-2" data-mp="3ikh9me1wn113">
        <Hero data-id="element-3" data-mp="3iiweam7rne26" />
        <MaterialsSection data-id="element-4" data-mp="3ij61k21ff746" />
        <ScreenTime data-id="element-5" data-mp="3ihuyk4ft23e4" />
        <ForYourChild data-id="element-6" data-mp="3mlawr57iwbsx" />
        <HowItWorks data-id="element-7" data-mp="3mkrchhuehbbq" />
        <WhyItWorks data-id="element-8" data-mp="3mk83wrqn3zad" />
        <VideoPreview data-id="element-9" data-mp="3mjgannkimdn9" />
        <ProjectsGallery data-id="element-10" data-mp="3rc9co3oln7vn" />
        <WhatsIncluded data-id="element-11" data-mp="3rbzo8kj7d8s2" />
        <Offer data-id="element-12" data-mp="3rcsy3udgkeef" />
        <BonosCarousel data-id="element-13" data-mp="3rd17vdeab3le" />
        <Testimonials data-id="element-14" data-mp="5yi8qe3h5da" />
        <FinalOffer data-id="element-15" data-mp="67z9oh5w26u" />
        <Faq data-id="element-16" data-mp="4n5i12o8na1" />
      </main>
      <Footer data-id="element-17" data-mp="82ld64660ci" />
      <StickyCta data-id="element-18" data-mp="7sxbo2oq39g" />
    </div>;
}